import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import EditContext from '@/ViewModels/Contexts/EditContext';
import KeepAliveHandler from '@/Management/KeepAliveHandler';
import * as CoreFrameDTOs from "coreframetypings/dto";

export default class LanguageUIListener extends UIListener {

    constructor() {
        super();
    }

    /**
     * @override
     */
    public onDetailViewReady(context: DetailViewContext): void {
        super.onDetailViewReady(context);
        
        this.updateVisibilityOnMethod('ImportLanguageFile', 'Show_ImportLanguageFile', context);
        this.updateVisibilityOnMethod('ImportLanguageFileIncremental', 'Show_ImportLanguageFileIncremental', context);
    }

    /**
     * @override
     */
    public onGenericObjectUpdated(context: EditContext, updatedProperties: Record<string, any>) : void {
        super.onGenericObjectUpdated(context, updatedProperties);

        if (updatedProperties.hasOwnProperty('Show_ImportLanguageFile')) {
            this.updateVisibilityOnMethod('ImportLanguageFile', 'Show_ImportLanguageFile', context as DetailViewContext);
        }

        if (updatedProperties.hasOwnProperty('Show_ImportLanguageFileIncremental')) {
            this.updateVisibilityOnMethod('ImportLanguageFileIncremental', 'Show_ImportLanguageFileIncremental', context as DetailViewContext);
        }
    }
    
    private updateVisibilityOnMethod(method: string, parameter: string, context: DetailViewContext): void {
        if (!context.toolBar)
            return;
        
        const element = context.toolBar.getElementByMethodName(method);
        if (element != null) {
            const isVisible = context.genericObject.getValue<boolean>(parameter);
            element.isVisible(isVisible);
        }
    }

    /**
     * @override
     */
    public onBeforeCallOperation(context: any, operation: string) : boolean {
        KeepAliveHandler.getInstance().disableAutoLogout = true;

        return true;
    }

    /**
     * @override
     */
    public onAfterCallOperation(context: DetailViewContext, operation: string, args: CoreFrameDTOs.IOperationResultDTO) : void {
        KeepAliveHandler.getInstance().disableAutoLogout = false;
    }
}

ComponentManager.setUIListener('LanguageUIListener', LanguageUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.LanguageUIListener', LanguageUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');